import { render, staticRenderFns } from "./ClipboardButton.vue?vue&type=template&id=fc37fea6&"
import script from "./ClipboardButton.vue?vue&type=script&lang=ts&"
export * from "./ClipboardButton.vue?vue&type=script&lang=ts&"
import style0 from "./ClipboardButton.vue?vue&type=style&index=0&id=fc37fea6&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports